<template>
  <v-card
    :style="`${mobile ? 'height: 250px !important' : 'height: 400px'}`"
    class="px-6"
    flat
  >
    <v-row no-gutters justify="space-between" class="py-4 pt-8">
      <span class="title-queue">{{ $t("queue.youAreInQueue") }}</span>
    </v-row>
    <v-row no-gutters>
      <span class="subtitle-queue">{{ $t("queue.pageOpen") }}</span>
    </v-row>
    <v-row no-gutters align="center" class="my-4">
      <div class="box-queue">
        <v-row no-gutters align="center">
          <span class="text-queue"
            >{{ $t("queue.yourPosition") }}
            <span class="number-queue pl-1">{{
              position ? position.toFixed(0) : "-"
            }}</span></span
          >
          <v-spacer></v-spacer>
          <v-progress-circular
            class="mr-2"
            indeterminate
            color="#1976d2"
            style="color: #1976d2 !important"
          ></v-progress-circular>
        </v-row>
      </div>
    </v-row>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex/dist/vuex.common.js";

export default {
  data() {
    return {
      interval: null,
      status: "",
      position: null,
      timeInterval: 30000,
    };
  },
  watch: {
    status(v) {
      if (v === "L") {
        this.$store.commit("SET_QUEUE", null);
        clearInterval(this.interval);
        this.$store.commit("SET_FINISHED_QUEUE", true);
      }
    },
  },
  computed: {
    ...mapGetters(["eventId"]),
    mobile() {
      switch (this.$vuetify.breakpoint.name) {
        case "xs":
          return true;
        case "sm":
          return true;
      }
      return false;
    },
  },
  destroyed() {
    clearInterval(this.interval);
  },
  methods: {
    returnTimeInterval(value) {
      if (value && value <= 250) return 15000;
      else if (value && value > 250 && value <= 500) return 30000;
      else if (value && value > 500 && value <= 1500) return 45000;
      else if (value && value > 1500 && value <= 5000) return 60000;
      else if (value && value > 5000) return 90000;
      return 30000;
    },
    async dropPosition(newPosition) {
      this.timeInterval = this.returnTimeInterval(newPosition);
      if (!this.position) this.position = newPosition;
      else {
        if (this.position === newPosition) return;
        let drop,
          timeDrop = 0;
        drop = (this.position - newPosition) / 4;
        timeDrop = this.timeInterval / 4;
        setTimeout(() => {
          this.position = this.position - drop;
        }, timeDrop);
        setTimeout(() => {
          this.position = this.position - drop;
        }, timeDrop * 2);
        setTimeout(() => {
          this.position = this.position - drop;
        }, timeDrop * 3);
        setTimeout(() => {
          this.position = this.position - drop;
        }, timeDrop * 4);
      }
    },
    getQueue() {
      let uuid = JSON.parse(localStorage.getItem(`queue_uuid_${this.eventId}`));
      this.$store
        .dispatch("getQueue", {
          event: this.eventId,
          uuid: uuid ? uuid.uuid : "",
        })
        .then(async (resp) => {
          if (resp.data && resp.data.success) {
            let obj = {
              uuid: resp.data.uuid,
              position: resp.data.position,
            };
            this.status = resp.data.status;
            this.$store.commit("SET_QUEUE", {
              show: true,
              text: resp.data.text,
            });
            await this.dropPosition(resp.data.position);
            localStorage.setItem(
              `queue_uuid_${this.eventId}`,
              JSON.stringify(obj)
            );
            clearInterval(this.interval);
            if (resp.data.status !== "L") {
              this.setIntervalQueue();
            }
          }
        });
    },
    setIntervalQueue() {
      this.interval = setInterval(() => {
        this.getQueue();
      }, this.timeInterval);
    },
  },
  mounted() {
    this.getQueue();
    this.setIntervalQueue();
  },
};
</script>

<style scoped>
.container-queue {
  height: 400px;
}
.title-queue {
  font-size: 24px;
  line-height: 28px;
  font-weight: 500;
  letter-spacing: -0.25px;
  text-align: left;
}
.subtitle-queue {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.25px;
  text-align: left;
}
.box-queue {
  height: 64px;
  width: 426px;
  padding: 10px 15px;
  background: #1976d23d;
  border-radius: 12px;
  display: flex;
  justify-content: start;
  align-items: center;
}
.text-queue {
  font-size: 14px;
  line-height: 16px;
  letter-spacing: -0.25px;
  text-align: right;
  font-weight: bold;
  color: #192b46;
}
.number-queue {
  font-size: 24px;
  line-height: 16px;
  letter-spacing: -0.25px;
  text-align: right;
  font-weight: bold;
  color: #192b46;
}
</style>
